import Auth0 from './configureAuth0';

// Since the Auth0 SDK method being used for getting the token does not return a promise,
// we'll have to wrap is so we can use await/async
const getAuthToken = () => {
  return new Promise((resolve, reject) => {
    Auth0.checkSession({}, (err, authResult) => {
      if (err) {
        reject(err);
      } else {
        resolve(authResult.accessToken);
      }
    });
  });
};

export default getAuthToken;
